// @flow
import React from 'react';
import styled from 'styled-components';
import ReactModal from 'react-modal';

import { colors, modalStyles } from '../../shared/styles';

const StyledContactRequestDetailModal = styled(ReactModal)`
    width: 680px;
    margin: 40px auto 0 auto;
    background: ${colors.white};
    border-radius: 4px;

    & .title {
        padding: 10px 20px;
        border-bottom: 1px solid ${colors.offWhite};
    }

    & .title h3 {
        margin: 0;
    }

    & .actions {
        text-align: right;
        padding: 10px;
        border-top: 1px solid ${colors.offWhite};
    }

    & .actions button, .actions a {
        padding: 5px 10px;
        border: 0;
        border-radius: 4px;
        margin-left: 10px;
        font-size: 14px;
        text-decoration: none;
    }

    & .actions .primary {
        background: ${colors.orange.default};
        color: ${colors.white};
    }

    & .content {
        min-height: 200px;
        background: #edf1f2;
        overflow-y: scroll;
        max-height: calc(100vh - 200px);
    }

    & .content-wrapper {
        padding: 20px 20px 20px 20px;
    }

    & .content img {
        max-width: 100%;
    }

    & .content .row {
        display: flex;
        padding-bottom: 10px;
    }

    & .content .col {
        flex: 1;
    }

    & .content .col p {
        margin: 0 20px 10px 0;
    }

    & h4 {
        margin: 0;
        font-weight: 700;
    }

    & img {
        padding-bottom: 20px;
    }

    & a {
        color: #000;
    }
`;

const ContactRequestDetailModal = (props: any) => {
    const { contactRequest, onCancel, isOpen, redirectToList } = props;

    return (
        <StyledContactRequestDetailModal
            contentLabel="Contact Request Details"
            shouldCloseOnOverlayClick={true}
            closeTimeoutMS={200}
            isOpen={isOpen}
            style={modalStyles}
        >
            <div className="title">
                <h3>Contact Request Details</h3>
            </div>
            {contactRequest &&
                <div className="content">
                    <div className="content-wrapper">
                        <div className="row">
                            <div className="col">
                                <h4>Name:</h4>
                                <p>
                                    {contactRequest.contactRequestName}
                                </p>
                                <h4>Region:</h4>
                                <p>
                                    {contactRequest.region &&
                                    contactRequest.region
                                        .contactRequestRegionSlug
                                        ? contactRequest.region
                                              .contactRequestRegionName
                                        : ''}
                                </p>
                                <h4>Property reference number:</h4>
                                <p>
                                    {
                                        contactRequest.contactRequestPropertyReference
                                    }
                                </p>
                            </div>

                            <div className="col">
                                <h4>Email:</h4>
                                <p>
                                    {contactRequest.contactRequestEmail}
                                </p>
                                <h4>Telephone:</h4>
                                <p>
                                    {contactRequest.contactRequestTelephone}
                                </p>
                                <h4>Message:</h4>
                                <p>
                                    {contactRequest.contactRequestMessage}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>}

            <div className="actions">
                {!redirectToList &&
                    <button className="primary" onClick={onCancel}>
                        Close
                    </button>}
                {redirectToList &&
                    <a className="primary" href="/contact-requests">
                        Close
                    </a>}
            </div>
        </StyledContactRequestDetailModal>
    );
};

export default ContactRequestDetailModal;



// WEBPACK FOOTER //
// ./src/components/ContactRequests/ContactRequestDetailModal.js